<template>
  <form class="row">
    <div class="form-group col-8">
      <label for="noteText">Notiz</label>
      <textarea v-model="noteText" @change="changedText" class="form-control" id="noteQuality" rows="3"></textarea>
    </div>
    <div class="col-1">
      <label for="wetWeight">Foto</label>
    </div>
    <div
        v-for="(image,index) in noteImages"
        :key="image.file"
        class="col-8 mb-3">
      <img :src="image.file" style="max-width: 100%;max-height: 300px"/>
      <button @click="resetPhoto(index)" class="del">-</button>
    </div>
    <div class="col-5">
      <input id="camera" ref="camera" @change="onFileChange" type="file"
             style="display: none" accept="image/*" capture="camera"/>
    </div>
    <div v-show="canWrite" class="col-2">
      <button class="mt-0 mb-0 pt-0 pb-0" type="submit" @click="openCamera" style="text-align: center">+</button>
    </div>
  </form>
</template>

<script>
export default {
  name: "WorkflowNotes",
  data() {
    return {
      noteText: '',
      noteImages: [],
      noteImage: null,
    }
  },
  props: {
    canWrite: {
      type: Boolean,
      default: false
    },
    noteData: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    if (this.noteData) this.noteText = this.noteData.text
  },
  methods: {
    changedText() {
      this.$props.noteData.text = this.noteText
    },
    openCamera(e) {
      e.preventDefault()
      this.$refs.camera.click()
      // this.scrollToTop()
    },
    onFileChange(e) {
      const file = e.target.files[0]

      this.noteImages.push({
        file: URL.createObjectURL(file),
        size: file.size,
        type: file.type,
        source: this.$refs.camera.files[0]
      })
      this.$props.noteData.images = this.noteImages
    },
    resetPhoto(e) {
      e.preventDefault()
      this.noteImage = null
    },
  }
}
</script>

<style scoped>

</style>